import styled from '@emotion/styled';
import FileIcon from '@/components/Record/SubjectContent/AttachmentFile/FileContent/FileIcon';
import Xbutton from '@/components/Record/SubjectContent/Xbutton';
import { useGetAudioLink } from '@/hooks/apiHooks';
import { useCallback } from 'react';

type P = {
  fileName: string;
  handleDelete?: () => void;
  uuid?: string;
  fileSize?: string;
};

const FileItem = ({ fileName, handleDelete, uuid, fileSize }: P) => {
  const { data: downloadLink } = useGetAudioLink(uuid);
  const handleDownload = useCallback(async () => {
    if (!downloadLink?.url || !downloadLink?.filename) return;

    try {
      const response = await fetch(downloadLink.url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = downloadLink.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl); // 메모리 정리
    } catch (err) {
      console.error('다운로드 실패:', err);
    }
  }, [downloadLink]);
  return (
    <Container onClick={handleDownload}>
      <FileIcon fileName={fileName} />
      <StyledTitle style={{ paddingRight: fileSize ? '2px' : '4px' }}>
        {fileName}
      </StyledTitle>
      {fileSize && <StyledFileSize>{fileSize}</StyledFileSize>}
      {handleDelete && <Xbutton onClick={handleDelete} />}
    </Container>
  );
};
export default FileItem;

const StyledFileSize = styled.div`
  overflow: hidden;
  color: var(--dk-text-secondary, #888d96);
  text-overflow: ellipsis;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  padding: 0 4px 0 2px;
`;

const Container = styled.div`
  padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background: var(--dk-bg-subtle, #f9fafb);
  display: flex;
  width: fit-content;
  cursor: pointer;
  align-items: center;
`;

const StyledTitle = styled.div`
  overflow: hidden;
  color: var(--dk-text-primary, #3f4254);
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  padding: 0 2px 0 4px;
  word-break: break-word;
`;
